import { HttpResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { InterfaceIndicator } from 'app/models/indicator.model';
import { IndicatorService } from 'app/services/indicator.service';
import { timezone } from 'assets/constants/timezone';
import { take } from 'rxjs/operators';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import * as dayjs from 'dayjs';
import * as utc from 'dayjs/plugin/utc';
import * as timezoneDayJs from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezoneDayJs);

@Component({
  selector: 'app-period-indicator',
  templateUrl: './period-indicator.component.html',
  styleUrls: ['./period-indicator.component.scss']
})
export class PeriodIndicatorComponent implements OnInit {

  @Input() indicator!: InterfaceIndicator;
  numbers: number[];
  periodType = true; // false = week, true = month
  formPeriod: FormGroup;
  isLoading = false;
  currentWeek: number;
  currentMonth: number;

  // data of the chart
  lineChartMulti: any;
  optionsChart: any;
  columnsChart: any;

  constructor(
    protected indicatorService: IndicatorService,
    protected fb: FormBuilder,
    public ngbActiveModal: NgbActiveModal
  ) {
    this.currentWeek = dayjs().tz(timezone).isoWeek();
    this.currentMonth = Number(dayjs().tz(timezone).format('MM'));
    this.numbers = [
      1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12
    ];
    this.formPeriod = this.fb.group({
      startsAt: [1, Validators.required],
      endsAt: [this.numbers[this.numbers.length - 1], Validators.required],
      year: [dayjs().tz(timezone).year(), Validators.required]
    });
  }

  ngOnInit(): void {
    this.togglePeriod(false);
    this.formPeriod.value.endsAt = this.currentWeek,
    this.setChartOptions();    
  }

  setChartOptions(): void {
    this.isLoading = true;
    const body = {
      period: this.periodType ? "monthNumber" : "weekNumber",
      startsAt: this.formPeriod.value.startsAt,
      endsAt: this.formPeriod.value.endsAt,
      yearNumber: this.formPeriod.value.year,
      indicator: this.indicator
    };
    this.indicatorService.getIndicatorChartPeriod(body).pipe(take(1)).subscribe((result: HttpResponse<any>) => {
      if (result && result.body) {
        this.optionsChart = {
          ...result.body.chartOptions,
          hAxis: {
            ...result.body.chartOptions.hAxis,
            gridlines: {color: 'transparent'},
            areaOpacity: 0.5
          },
          vAxis: {
            ...result.body.chartOptions.vAxis,
            gridlines: {color: 'transparent'},
            areaOpacity: 0.5

          },
          chartArea: { width: '80%', height: '70%' },
          fontSize: 12,
        }
        this.columnsChart = result.body.chartColums;
        this.lineChartMulti = result.body.chartData;
        console.log(this.lineChartMulti);
        this.isLoading = false;
      }
    }, (error: any) => {
      console.error(error);
    });
  }
  togglePeriod(flag: boolean): void {
    this.numbers = [];
    this.periodType = flag;
    if (this.periodType) {
      for (let i = 1; i < 13; i++) {
        this.numbers.push(i);
      }
      this.formPeriod.patchValue({
        startsAt: 1,
        endsAt: this.currentMonth
      });
      this.formPeriod.updateValueAndValidity();
    } else {
      for (let i = 1; i < 53; i++) {
        this.numbers.push(i);
      }
      this.formPeriod.patchValue({
        startsAt: 1,
        endsAt: this.currentWeek
      });
      this.formPeriod.updateValueAndValidity();
    }
  }

  returnFormat(amount: number): string {
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    switch (this.indicator.type) {
      case 1:
        if (amount) {
          return formatter.format(amount);
        } else {
          return formatter.format(0);
        }
      case 2:
        if (amount) {
          return amount + "%"
        } else {
          return "0%"
        }
      case 3:
        if (amount) {
          return amount.toString()
        } else {
          return "0";
        }
      default:
        return "";
    }
  }
}
